import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield } from 'lucide-react';
export const Hero = () => {
  const scrollToPricing = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 px-6 md:px-12 overflow-hidden" data-id="element-106">
      {/* Background decorative elements */}
      <div className="absolute inset-0 bg-radial-glow opacity-60 pointer-events-none" data-id="element-107" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-108" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start" data-id="element-110">
          <div className="flex items-center gap-2 text-gold mb-6 border border-gold/30 rounded-full px-4 py-1.5 bg-gold/5" data-id="element-111">
            <Shield size={16} data-id="element-112" />
            <span className="text-sm font-medium tracking-wider uppercase" data-id="element-113">
              Botiquín de Emergencia Post-Oficina
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-offwhite leading-[1.1] mb-6 text-balance" data-id="element-114">
            Deja de llevarte la oficina a tu casa:{' '}
            <span className="text-gold italic font-normal" data-id="element-115">
              Recuperá tu energía vital
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 font-light leading-relaxed mb-10 text-balance border-l-2 border-gold/50 pl-6" data-id="element-116">
            El protocolo de blindaje invisible para profesionales que están
            hartas de sentirse drenadas por ambientes tóxicos, envidias y el
            agotamiento mental.
          </p>

          <Button onClick={scrollToPricing} className="w-full sm:w-auto" data-id="element-117">
            ¡QUIERO MI BOTIQUÍN AHORA!
          </Button>
          <p className="mt-4 text-sm text-gray-400 font-light flex items-center gap-2" data-id="element-118">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-119" />
            Acceso inmediato tras la compra
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative" data-id="element-120">
          <div className="absolute -inset-4 bg-gold/10 rounded-lg blur-2xl" data-id="element-121" />
          <div className="relative rounded-sm border border-gold/20 p-2 bg-navy-900/50 backdrop-blur-sm" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/mkwE2Fk6HZMWtgdAKLxxBP/heylloyd-Blindaje_energetico.png" alt="Botiquín Energético en laptop" className="w-full h-auto rounded shadow-2xl" data-id="element-123" />
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-gold/50" data-id="element-124" />
            <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-gold/50" data-id="element-125" />
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-gold/50" data-id="element-126" />
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-gold/50" data-id="element-127" />
          </div>
        </motion.div>
      </div>
    </section>;
};